import { render } from "./notice.vue?vue&type=template&id=ee076370"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=ee076370&lang=scss"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__